"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function NewsConsumer() {
  const {
    posts,
    loading
  } = usePosts();
  if (loading) {
    return <div className="space-y-4">
        {[...Array(3)].map((_, i) => <div key={i} className="h-32 bg-secondary/5 border border-border/50 animate-pulse" />)}
      </div>;
  }
  if (posts.length === 0) {
    return <div className="p-8 border border-dashed border-border text-center">
        <p className="text-sm text-muted-foreground font-mono">Nessun aggiornamento disponibile al momento.</p>
      </div>;
  }
  return <div className="space-y-4">
      {posts.map((post, i) => <article key={post.id} data-index={i} className="group relative bg-card border border-border p-6 transition-all duration-300 hover:border-accent/50 hover:shadow-xl hover:shadow-black/10">
          <div className="absolute top-0 left-0 w-1 h-0 bg-accent transition-all duration-300 group-hover:h-full" />
          <div className="flex flex-col gap-3">
            <div className="flex items-center justify-between">
              <span className="text-[10px] font-mono font-bold uppercase tracking-widest text-accent">
                {post.date ? new Date(post.date).toLocaleDateString('it-IT') : 'News'}
              </span>
              <div className="w-1.5 h-1.5 rounded-full bg-border group-hover:bg-accent transition-colors" />
            </div>
            <h3 className="font-bold text-lg leading-tight text-foreground line-clamp-2 font-sans group-hover:text-primary transition-colors">
              {post.title}
            </h3>
            <Link to={post.link || "#"} className="mt-2 text-[11px] font-mono font-black uppercase tracking-tighter flex items-center gap-2 text-muted-foreground group-hover:text-foreground transition-colors">
              Dettagli Tecnici
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" className="transition-transform group-hover:translate-x-1">
                <path d="M5 12h14m-7-7 7 7-7 7" />
              </svg>
            </Link>
          </div>
        </article>)}
    </div>;
}
export default function BenvenutiInStudioMess() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const wp_query = React.useMemo(() => new WP_Query({
    post_type: "post",
    per_page: 3,
    order: "desc",
    orderby: "date"
  }), []);
  return <section id="benvenuti-in-studio-mess" className="dark bg-background text-foreground relative overflow-hidden min-h-[90vh] flex items-center py-20 !justify-center">
      {}
      <div className="absolute inset-0 pointer-events-none z-0" style={{
      backgroundImage: `
            linear-gradient(to right, var(--border) 1px, transparent 1px),
            linear-gradient(to bottom, var(--border) 1px, transparent 1px)
          `,
      backgroundSize: "50px 50px",
      opacity: 0.15
    }} aria-hidden="true" />

      {}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/10 rounded-full blur-[120px] pointer-events-none z-0" />
      <div className="absolute bottom-1/4 right-1/4 w-[30rem] h-[30rem] bg-accent/5 rounded-full blur-[150px] pointer-events-none z-0" />

      <div className="container px-4 relative z-10 ![margin:30px_0px_0px_0px] sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          
          {}
          <div ref={textRef} className={`w-full lg:w-[60%] flex flex-col justify-center transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            

            <h1 className="font-black tracking-tighter leading-[1.1] text-foreground mb-6 font-sans !text-[34px]">Progettazione, Sicurezza e Prevenzione Incendi <br />Il tuo partner tecnico per imprese e cantieri</h1>

            <p className="text-lg sm:text-xl text-muted-foreground max-w-2xl mb-10 leading-relaxed font-light">Guidato dall’esperienza del Per. Ind. Felice Mesuraca, Studio MESS S.r.l. offre consulenze ingegneristiche di alto livello. Dalla progettazione architettonica e strutturale alla direzione lavori, dal coordinamento della sicurezza in fase di progettazione ed esecuzione (CSP/CSE) alla consulenza in materia di salute e sicurezza sul lavoro ai sensi del D.Lgs. 81/08, inclusi incarichi di RSPP, fino alla prevenzione e progettazione antincendio, supportiamo le imprese garantendo conformità normativa, innovazione e affidabilità.</p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="h-14 px-8 text-base font-semibold shadow-lg shadow-primary/20">
                <Link to="/ServicesPage">
                  I Nostri Servizi
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="h-14 px-8 text-base font-semibold backdrop-blur-sm bg-background/50 border-border/50 hover:bg-secondary/20">
                <Link to="#richiedi-una-consulenza">
                  Contattaci
                </Link>
              </Button>
            </div>

            {}
            
          </div>

          {}
          <div ref={imageRef} className={`w-full lg:w-[40%] relative transition-all duration-1000 delay-300 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="flex flex-col gap-8">
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <div className="h-px w-8 bg-accent" />
                  <h2 className="text-2xl font-black tracking-tighter uppercase text-foreground font-sans">
                    Aggiornamenti & Normative
                  </h2>
                </div>
                <p className="text-xs text-muted-foreground font-mono uppercase tracking-widest pl-11">
                  Ultime dal settore tecnico
                </p>
              </div>

              <PostsProvider wp_query={wp_query}>
                <NewsConsumer />
              </PostsProvider>
            </div>
            
            {}
            <div className="absolute -top-4 -right-4 w-24 h-24 border-t-2 border-r-2 border-primary/30 rounded-tr-3xl pointer-events-none" />
            <div className="absolute -bottom-4 -left-4 w-24 h-24 border-b-2 border-l-2 border-primary/30 rounded-bl-3xl pointer-events-none" />
          </div>

        </div>
      </div>
    </section>;
}